import { getHostedIdentifySessionRequirements, postHostedIdentifySessionVerify } from '@onefootprint/fetch-hosted';
import type { IdentifyRequirement, IdentifyRequirementsResponse } from '@onefootprint/request-types';

type LoadRequirementsResult =
  | ({ kind: 'handleNextRequirement'; requirement: IdentifyRequirement } & Omit<
      IdentifyRequirementsResponse,
      'requirements'
    >)
  | { kind: 'done'; authToken: string };

const loadNextRequirement = async (identifyToken: string): Promise<LoadRequirementsResult> => {
  const { data } = await getHostedIdentifySessionRequirements({
    headers: { 'X-Fp-Authorization': identifyToken },
  });

  const { requirements, ...restOfData } = data;
  const requirement = requirements[0];
  if (requirement) {
    return { kind: 'handleNextRequirement', requirement, ...restOfData };
  }

  // No remaining requirements, we're done. Get the auth token
  const { data: verifyData } = await postHostedIdentifySessionVerify({
    headers: { 'X-Fp-Authorization': identifyToken },
  });

  return { kind: 'done', authToken: verifyData.authToken };
};

export default loadNextRequirement;
